/* tslint:disable */

declare var Object: any;
export interface FixrAPIInterface {
  "id"?: number;
}

export class FixrAPI implements FixrAPIInterface {
  "id": number;
  constructor(data?: FixrAPIInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `FixrAPI`.
   */
  public static getModelName() {
    return "FixrAPI";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of FixrAPI for dynamic purposes.
  **/
  public static factory(data: FixrAPIInterface): FixrAPI{
    return new FixrAPI(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'FixrAPI',
      plural: 'FixrAPI',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/FixrAPI.ts